import React from 'react';
import QuoteRequestForm, { BrochureBtn, ImgRender } from '../../BFComponents';

const Intimus60cp4 = () => {
    return (

        <div className="container">
            <div className="row">
                <div className="col d-flex flex-row-reverse">
                    <ImgRender image={"intimus-logo.svg"} normal={true} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-4">
                    <div className="jumbotron">
                        <ImgRender image={"infosec.png"} width={100} />
                        <h1>INTIMUS 60</h1>
                        <h5>IN THE OFFICE</h5>
                        <ul>
                            <li>Low noise level</li>
                            <li>Integrated Auto Reverse Function for easy removal of paper jams</li>
                            <li>Illuminated indicators for stand-by, basket full, door open and paper jam</li>
                            <li>Sealed dust-free design with robust wooden cabinet</li>
                            <li>Mounted on rollers for flexible use</li>
                        </ul>
                        <div className="d-flex justify-content-center">
                            <ImgRender image={"intimus60cp42.jpg"} />
                        </div>

                    </div>
                </div>
                <div className="col-md-8">
                    <div className="row justify-content-center">
                        <div className="col-md-6" >
                            <ImgRender image={"intimus60cp4.jpg"} width={100} cssClass={"my-4"} />
                        </div>
                    </div>
                    <div className="d-flex flex-column">
                        <QuoteRequestForm source={window.location} />
                        <BrochureBtn brochure={"Intimus 60CP4 Shredder Brochure.pdf"} />
                    </div>
                </div>
                <div id="intimuspro" className="col-md-4 d-flex justify-content-end">
                    <div className="text-right align-self-center">
                        <h2 id="intimus">PROFESSIONAL<br />
DATA SHREDDERS</h2></div>

                </div>
                <div className="col-md-8 u-line-spacing">
                    – a Synthesis of Technology, Performance and Design. All intimus® shredders
                    are built from durable, precision engineered, high-performance components, designed for a long life of high volume usage. The product range covers all requirements from day-to-day office use up to High Security Shredding machines in use for destruction of classified material in line with all current legal requirements such as DIN 66399 or NSA 02/01. intimus® shredders carry various features which make them unique in user-friendliness and operating efficiency.
                </div>
            </div>
        </div>
    )
}

export default Intimus60cp4;

